import { api } from "@shared/lib/api/client";

export type ProductResult = {
  id: string;
  name: string;
  slug: string;
  sku?: string | null;
  priceMin: number;
  status: string;
  imageUrl?: string | null;
};

export type OrderResult = {
  id: string;
  orderNumber: string;
  customerName: string;
  total: number;
  status: string;
  createdAt: string;
};

export type CustomerResult = {
  id: string;
  name: string;
  email: string;
  phone: string;
};

export type GlobalSearchResult = {
  products: ProductResult[];
  orders: OrderResult[];
  customers: CustomerResult[];
};

export async function globalSearch(query: string): Promise<GlobalSearchResult> {
  if (!query) return { products: [], orders: [], customers: [] };
  const res = await api.get<GlobalSearchResult>(`/api/admin/search`, {
    params: { q: query },
  });
  return res.data;
}
